import { render, staticRenderFns } from "./delivery-list.vue?vue&type=template&id=7e5e1c3c&scoped=true&"
import script from "./delivery-list.vue?vue&type=script&lang=js&"
export * from "./delivery-list.vue?vue&type=script&lang=js&"
import style0 from "./delivery-list.sass?vue&type=style&index=0&id=7e5e1c3c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5e1c3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/goeatBackup/goeat-backup-goeat-order-line/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VCard,VDialog,VFlex,VIcon,VLayout,VProgressCircular})
